import { WidgetSystemConfig } from "../types/widget-systems";

export const widgetSystemConfig: WidgetSystemConfig = {
  defaultRefreshInterval: 5 * 60 * 1000, // 5 минут
  defaultCacheTimeout: 60 * 1000, // 1 минута
  maxLogs: 1000,
  enableLogging: process.env['NODE_ENV'] === "development",
};

// Конфигурация для разных типов виджетов
export const widgetTypeConfig = {
  kpi: {
    refreshInterval: 5 * 60 * 1000, // 5 минут
    cacheTimeout: 60 * 1000, // 1 минута
  },
  chart: {
    refreshInterval: 15 * 60 * 1000, // 15 минут
    cacheTimeout: 5 * 60 * 1000, // 5 минут
  },
  table: {
    refreshInterval: 10 * 60 * 1000, // 10 минут
    cacheTimeout: 2 * 60 * 1000, // 2 минуты
  },
  list: {
    refreshInterval: 5 * 60 * 1000, // 5 минут
    cacheTimeout: 60 * 1000, // 1 минута
  },
  status: {
    refreshInterval: 30 * 1000, // 30 секунд
    cacheTimeout: 15 * 1000, // 15 секунд
  },
  progress: {
    refreshInterval: 60 * 1000, // 1 минута
    cacheTimeout: 30 * 1000, // 30 секунд
  },
  map: {
    refreshInterval: 5 * 60 * 1000, // 5 минут
    cacheTimeout: 60 * 1000, // 1 минута
  },
};

// Конфигурация для обработки ошибок
export const errorHandlingConfig = {
  maxRetries: 3,
  retryDelay: 1000, // 1 секунда
  errorThreshold: 5, // Максимальное количество ошибок перед отключением автообновления
  errorResetInterval: 30 * 60 * 1000, // 30 минут
};

// Конфигурация для метрик
export const metricsConfig = {
  collectionInterval: 5 * 60 * 1000, // 5 минут
  retentionPeriod: 24 * 60 * 60 * 1000, // 24 часа
  alertThresholds: {
    errorRate: 0.1, // 10%
    loadTime: 2000, // 2 секунды
    cacheHitRate: 0.8, // 80%
  },
};
